import { useState } from "react";

const navLinks = [
  { label: "今日热议榜", href: "#rank" },
  { label: "分区合集", href: "#forums" },
  { label: "争议焦点", href: "#fights" },
  { label: "评论区切片", href: "#clips" },
  { label: "实时短讯", href: "#feed" },
  { label: "风向温度", href: "#pulse" },
];

export default function TopNav() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 font-serif text-base font-black text-background-50">
            嘿
          </span>
          <span className="flex items-baseline gap-1">
            <span className="font-serif text-xl font-black tracking-tight text-foreground-950">
              51嘿料
            </span>
            <span className="hidden text-xs text-foreground-500 sm:inline">热议 · 评论区 · 舆论风向</span>
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex">
          {navLinks.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#feed"
            className="flex h-9 items-center whitespace-nowrap rounded-md bg-primary-500 px-4 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            围观热议流
          </a>
        </nav>

        <button
          type="button"
          aria-label="展开导航"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-700 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-lg`} />
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
          </div>
        </nav>
      )}
    </header>
  );
}